<template lang="html">
  <modal-template
    ref="modal"
    modal-size="sm"
    title="Adicionar Tabela de Preço"
    type-modal="add_price_type_modal"
  >
    <div class="modal-content__main">
      <d-form @submit.prevent="save">
        <d-form-row>
          <d-col md="12" class="form-group">
            <label for="autocomplete">Tabela de Preço</label>
            <autocomplete
              ref="autocomplete"
              id="autocomplete"
              placeholder="Selecione uma tabela de preço..."
              :items="priceTables.list"
              item-show="name"
              :on-input="onInputPriceTable"
              :on-select="onSelectPriceTable"
            />
          </d-col>
        </d-form-row>
      </d-form>
    </div>

    <div slot="actions" class="modal-content__control">
      <d-button
        type="button"
        @click="cancel"
        class="btn btn-sm btn-secondary mr-4"
      >
        Cancelar
      </d-button>
      <d-button
        type="button"
        @click="save"
        class="btn btn-sm btn-primary"
      >
        Salvar
      </d-button>
    </div>
  </modal-template>
</template>

<script>
import { mapActions } from 'vuex';
import ModalTemplate from '_shared/Modal.vue';
import Autocomplete from '_shared/Autocomplete.vue';
import ProductService from '_services/rest/modules/product';

export default {
  name: 'add-price-type-modal',
  components: {
    ModalTemplate,
    Autocomplete,
  },
  data() {
    return {
      selectedPriceTable: null,
      pagination: {
        search: '',
        skip: 0,
        take: 10,
        page: 1,
      },
    };
  },
  computed: {
    priceTables() {
      const { priceTableNames } = this.$store.state.product;
      if (priceTableNames && priceTableNames.list.length) {
        return priceTableNames;
      }
      return {
        list: [],
        total_items: 0,
      };
    },
  },
  methods: {
    ...mapActions([
      'setToggle',
      'activeAlert',
      'getPriceTableNames',
      'setProductPriceNames',
    ]),
    onInputPriceTable(name) {
      this.pagination.search = name;
      clearTimeout(this.searchTimeoutId);
      this.searchTimeoutId = setTimeout(() => {
        this.getPriceTableNames(this.pagination);
      }, 400);
    },
    onSelectPriceTable(priceTable) {
      this.selectedPriceTable = priceTable;
    },
    save() {
      const { product } = this.$store.state.product;

      const priceTable = this.selectedPriceTable || { id: null, name: this.pagination.search };

      ProductService.syncPrices(product.id, priceTable)
        .then(response => {
          const priceNames = response.price_names;
          this.setProductPriceNames(priceNames);
          this.activeAlert({ message: 'Tabelas de preço atualizadas com sucesso!', theme: 'success' });
          this.setToggle({ type: 'add_price_type_modal', bool: false });
        }).catch(() => {
          this.activeAlert({ message: 'Erro ao salvar tabela de preço.', theme: 'danger' });
        });
    },
    cancel() {
      this.setToggle({ type: 'add_price_type_modal', bool: false });
    },
  },
};
</script>
